import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { fetchUsers, shareQuestion } from "../../../API/api";
import { createLink } from "../../../utils";
import styles from "../ShareQuestionModal/ShareQuestionStyles.module.css";
import Button2 from "../../../NewComponent/Button2/Button2";
import Button from "../../../NewComponent/Button/Button";
import { ModalHeader } from "../../../Constants";
import SwitchComp from "../../../NewComponent/Switch/Switch";

const submitSuccessToast = () => {
    return (
        <>
            <span style={{ fontSize: "12px" }}>
                You have successfully shared the Question.
            </span>
        </>
    );
};
export default function ShareQuestionExpertOpenModal() {
    const currentRole = localStorage.getItem('ngStorage-currentRole');
    const expertState = useSelector((state) => state.expertOpenData);
    const dispatch = useDispatch();
    const [isLinkShare, setIsShareLink] = useState(
         expertState.selectedQuestion.sharing
    );
    const { advanceFilterModalToggle, getExpertOpenData } = bindActionCreators(
        Actions,
        dispatch
    );
    const [searchedUser, setSearchUsers] = useState([]);
    const [inputval, setInputVal] = useState("");
    const [selected, setSelected] = useState(
       expertState.selectedQuestion.sharedWith || [] 
    );
    const modalState = useSelector((state) => state.domain);
    const [isCopied, setIsCopied] = useState(false);
    const onChangeSharelinkToggle = (flag) => {
        setIsShareLink(flag);
    };

    const onChangeInput = (e) => {
        setInputVal(e.target.value);
        if (e.target.value.length > 3) {
            fetchUsers(e.target.value, false)
                .then((res) => {
                    if (res===undefined) return;
                    let filtered = res.data.data.users.filter(function (obj) {
                        let found = false;
                        selected.filter((obj2) => {
                            if (obj2.userUuid === obj.userUuid || obj2.userUuidStr === obj.userUuid) {
                                found = true;
                            }
                        });
                        if (found === false) {
                            return obj;
                        }
                    });
                    setSearchUsers(filtered);
                })
                .catch((err) => { });
        }
    };
    const onClickUsers = (val) => {
        setSelected([...selected, val]);
        setSearchUsers([]);
        setInputVal("");
    };

    const onClickRemoveUsers = (val) => {
        let filteredData = selected.filter((obj) => {
            if (obj.userUuid === undefined) {
                if (obj.userUuidStr !== val) {
                    return obj;
                }
            } else {
                if (obj.userUuid !== val) {
                    return obj;
                }
            }
        });
        setSelected(filteredData);
    };

    const copyShareQuestionLink = () => {
        setIsCopied(true);
        window.navigator.clipboard.writeText(
            createLink(expertState.selectedQuestion)
        );
    };

    const onSubmitShareQuestion = () => {
        let requiredQuestion = expertState.selectedQuestion;
        let sharableLinkCreated = createLink(requiredQuestion);
        if (requiredQuestion.sharedWith === undefined) {
            requiredQuestion.sharedWith = [];
            requiredQuestion.sharedWithClone = requiredQuestion.sharedWith;
            requiredQuestion.sharingClone = requiredQuestion.sharing;
        } else {
            requiredQuestion.sharedWithClone = requiredQuestion.sharedWith;
            requiredQuestion.sharingClone = requiredQuestion.sharing;
        }
        let selectedData = selected.filter((user) => {
            if (user.userUuidStr === undefined) {
                user.userUuidStr = user.userUuid;
            }
            return user;
        });
        setSelected(selectedData);
        requiredQuestion.postedTimestamp = Date.parse(
            new Date(requiredQuestion.postedTimestamp)
        );
        requiredQuestion.sharing = isLinkShare;
        requiredQuestion.sharedWith = selected;

        if (requiredQuestion.origQuestionUuid !== undefined) {
            requiredQuestion.questionUuid = requiredQuestion.origQuestionUuid;
        }
        let payload = {
            question: requiredQuestion,
            users: selected,
            sharing: isLinkShare,
            link: btoa(requiredQuestion.questionUuid),
        };
        advanceFilterModalToggle({ bool: false, value: "" });
        shareQuestion(payload)
            .then((res) => {
                if (res===undefined) return;
                if (res.data.success) {
                    if (currentRole === 'Expert') {
                        let filteredData = expertState.data.filter((question) => {
                            if (
                                question.questionUuid ===
                                expertState.selectedQuestion.questionUuid
                            ) {
                                question.sharedWith = selected;
                            }
                            return question;
                        });
                        getExpertOpenData(filteredData);
                    }
                    toast.success(submitSuccessToast(), {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch((err) => { });
    };
    return (
        <>
            <Modal
                show={modalState.modalState}
                onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
                centered={true}
                size={"lg"}
                dialogClassName={styles.modalDialog}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={ModalHeader.styles}>
                        <span className="fa fa-users"></span>
                        &nbsp;&nbsp;Share with Teammates
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12 col-lg-12">
                        <Form
                            style={{ border: "lightgray solid 1px", borderRadius: "5px" }}
                        >
                            {selected.length > 0 && (
                                <div
                                    className="mt-2 ms-2"
                                    style={{ display: "flex", flexWrap: "wrap" }}
                                >
                                    {selected.map((obj) => {
                                        return (
                                            <p className={styles.selectedUserSQM}>
                                                {obj.firstName} {obj.lastName} {`<${obj.email}>`}{" "}
                                                <span
                                                    className={styles.crossbuttonSQM}
                                                    onClick={() => onClickRemoveUsers(obj.userUuid === undefined ? obj.userUuidStr : obj.userUuid)}
                                                >
                                                    x
                                                </span>
                                            </p>
                                        );
                                    })}
                                </div>
                            )}
                            <Form.Group
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Control
                                    as="input"
                                    value={inputval}
                                    rows={3}
                                    placeholder="Enter name or email address"
                                    autoComplete="off"
                                    style={{ border: "none", fontSize: "13px" }}
                                    onChange={(e) => onChangeInput(e)}
                                />
                            </Form.Group>
                        </Form>
                        {searchedUser.length > 0 && (
                            <div
                                className={styles.watchListUserslist}
                                style={{
                                    width: "96%",
                                    position: "absolute",
                                    zIndex: "1000",
                                    background: "#FFF",
                                }}
                            >
                                {searchedUser.map((user) => {
                                    return (
                                        <div
                                            style={{
                                                padding: "7px",
                                                border: "lightgrey solid 1px",
                                                borderRadius: "5px",
                                                fontSize: "12px",
                                            }}
                                        >
                                            <span value={user} onClick={() => onClickUsers(user)}>
                                                {user.firstName} {user.lastName} {`<${user.email}>`}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        <h2 className={styles.modalDividerHeader}>
                            <span className={styles.modalDivider}>or</span>
                        </h2>
                        <div className={styles.shareableContent}>
                            <Form.Group className="col-md-12">
                                <label style={{marginRight:'5px',marginBottom:'7px'}}>
                                        {/* <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            checked={isLinkShare}
                                            onChange={(e) =>
                                                onChangeSharelinkToggle(e.target.checked)
                                            }
                                        /> */}
                                <SwitchComp val={isLinkShare} onChangeFunc={onChangeSharelinkToggle} />
                                </label>
                                <span
                                style={{
                                    fontWeight: 500,
                                    textTransform: "capitalize",
                                    color: "rgb(92, 102, 123)",
                                    fontSize: "14px",
                                }}
                            >
                                enable link sharing{" "}(anyone in your organization can view this link)
                            </span>
                                {isLinkShare && (
                                    <div style={{display:'flex',justifyContent:'space-between'}}>
                                        <div style={{width:'88%',marginBottom:'5px'}}>
                                            <textarea
                                                value={createLink(expertState.selectedQuestion)}
                                                style={{
                                                    width: "100%",
                                                    borderColor: "lightgrey",
                                                    fontSize: "13px",
                                                    color: "#5c667b",
                                                    resize:'none',
                                                    outline:'none',
                                                    borderRadius:'6px',
                                                    padding:'5px',
                                                    gap:'2px',
                                                    height:'40px'
                                                }}
                                                rows={1}
                                            ></textarea>
                                        </div>
                                        <div
                                            style={{fontSize: "14px",paddingLeft:0 }}
                                        >
                                                {/* {!isCopied ? "Copy Link" : "Copied!"} */}
                                                <Button text={!isCopied ? "Copy Link" : "Copied!"} type='primary' onClickFunc={()=>copyShareQuestionLink()} />
                                        </div>
                                    </div>
                                )}
                            </Form.Group>
                            <hr
                                style={{
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                    borderColor: "#CCCCCC",
                                    borderWidth: "1px",
                                }}
                            ></hr>
                            <div style={{ textAlign: "right",display:'flex',gap:'5px',justifyContent:'flex-end' }}>
                                {/* <button
                                    className={styles.cancelButton}
                                    onClick={() =>
                                        advanceFilterModalToggle({ bool: false, value: "" })
                                    }
                                >
                                    cancel
                                </button> */}
                                <Button2 type="dark" children={'Cancel'} onClickFunc={() => advanceFilterModalToggle({ bool: false, value: "" })
                                } />
                                {/* <button
                                    className={styles.shareResponseButton}
                                    onClick={() => onSubmitShareQuestion()}
                                    disabled={selected.length === 0 ? true : false}
                                >
                                    share response
                                </button> */}
                                <Button disabled={selected.length === 0 ? true : false} onClickFunc={()=>onSubmitShareQuestion()} type={'primary'} text='Share Response'  />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
